// @jsx h @flow
import { h } from 'preact'
import { PureComponent } from '../../../lib/pureComponent'

const IS_CLIENT = typeof window !== 'undefined'

type Props = {
  path: string,
  isDynamic?: boolean
}

type State = {
  fetchedHtml: string | null
}

export class EsiInclude extends PureComponent<Props, State> {
  state = {
    fetchedHtml: null
  }

  componentDidMount(): void {
    const { isDynamic, path } = this.props
    if (isDynamic) {
      fetch(path, { mode: 'cors' })
        .then(res => res.text())
        .then(body => this.setState({ fetchedHtml: body }))
    }
  }

  componentDidUpdate(prevProps: Props): void {
    const { isDynamic, path } = this.props
    if (prevProps.path !== path) {
      if (isDynamic) {
        fetch(path, { mode: 'cors' })
          .then(res => res.text())
          .then(body => this.setState({ fetchedHtml: body }))
      }
    }
  }

  render() {
    const { path, isDynamic } = this.props
    const esiUrl = path
    if (!isDynamic) {
      if (IS_CLIENT) {
        const html = global.document.querySelector(`[data-esi-url="${esiUrl}"]`)
        if (html) {
          return <div data-esi-url={esiUrl} dangerouslySetInnerHTML={{ __html: html.innerHTML }} />
        }
        return null
      }
      return <div data-esi-url={esiUrl} dangerouslySetInnerHTML={{ __html: `<esi:include src="${esiUrl}" />` }} />
    } else {
      const { fetchedHtml } = this.state
      if (!fetchedHtml) {
        return <div />
      } else {
        return <div data-esi-url={esiUrl} dangerouslySetInnerHTML={{ __html: fetchedHtml }} />
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/common/EsiInclude.js